import React from 'react';

import { Box } from '@material-ui/core';
import { AlertTitle } from '@material-ui/lab';

import { string, oneOf, array, object } from 'prop-types';
import generate from 'shortid';

import { AlertStyled, FadeStyled, Message } from './styles';

function InfoMessage({ message, messages, type, title, variant, boxProps, ...others }) {
  const isMessages = messages.length > 0;
  const isIn = Boolean(message || title || isMessages);

  return (
    <Box {...boxProps}>
      <FadeStyled in={isIn} unmountOnExit timeout={500}>
        <AlertStyled severity={type} variant={variant} {...others}>
          {title && <AlertTitle>{title}</AlertTitle>}
          {message}
          {isMessages && messages.map((msg) => <Message key={generate()}>{msg}</Message>)}
        </AlertStyled>
      </FadeStyled>
    </Box>
  );
}

InfoMessage.defaultProps = {
  type: 'warning',
  messages: [],
  boxProps: {},
};

InfoMessage.propTypes = {
  message: string,
  messages: array,
  title: string,
  type: oneOf(['error', 'warning', 'info', 'success']),
  variant: oneOf(['filled', 'outlined', 'standard']),
  boxProps: object,
};

export default InfoMessage;
